export class ClientError extends Error {
  status: number;

  constructor(status: number) {
    super('ClientError');
    this.name = 'ClientError';
    this.status = status;

    Object.setPrototypeOf(this, ClientError.prototype);
  }
}
